import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/react';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ProjectDetail from './pages/ProjectDetail';
import Reports from './pages/Reports';
import Profile from './pages/Profile';
import Team from './pages/Team';
import Logs from './pages/Logs';

function PrivateRoute({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  if (!isLoaded) return <div style={{ color: 'var(--color-muted)', padding: 40, fontFamily: 'sans-serif' }}>Loading...</div>;
  return isSignedIn ? children : <Navigate to="/login" />;
}

function RootRoute() {
  const { isLoaded, isSignedIn } = useAuth();
  if (!isLoaded) return null;
  if (isSignedIn) return <Navigate to="/dashboard" />;
  // A real page load at / is served directly by nginx/craco.config.js
  // (the landing page lives at the site root, not /landing.html) -- this
  // only runs for a signed-out visitor already inside the loaded React
  // app, so a full navigation back to / re-fetches the marketing page.
  window.location.href = '/';
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRoute />} />
        <Route path="/login/*" element={<Login />} />
        <Route path="/register/*" element={<Register />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/projects/:id" element={<PrivateRoute><ProjectDetail /></PrivateRoute>} />
        <Route path="/projects/:id/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
        <Route path="/logs" element={<PrivateRoute><Logs /></PrivateRoute>} />
        <Route path="/profile/*" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/team/*" element={<PrivateRoute><Team /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  );
}
